export default {
  weather: null,
  error: false,
  errorMessage: '',
}